import React from 'react';
import { useParams } from 'react-router-dom';
import TaskListManagement from '../components/tasks/TaskListManagement';

const Tasks: React.FC = () => {
  const { id: projectId } = useParams<{ id: string }>();

  return (
    <TaskListManagement
      projectId={projectId}
      title="Task Management"
      description="Manage project tasks, assignments, and progress"
    />
  );
};

export default Tasks;
